import type { EconomicsCalendarResponse, EconomicsRevisionResponse, EconomicsSnapshot, RateHistoryRange, RateHistoryResponse } from "./types";

export async function fetchEconomicsSnapshot(): Promise<EconomicsSnapshot> {
  return fetchEconomicsJSON<EconomicsSnapshot>("/api/economics/snapshot","Economics snapshot");
}

export async function fetchEconomicsCalendar(from?:string,to?:string):Promise<EconomicsCalendarResponse>{
  const params=new URLSearchParams();if(from)params.set("from",from);if(to)params.set("to",to);const query=params.toString();
  return fetchEconomicsJSON<EconomicsCalendarResponse>(`/api/economics/calendar${query?`?${query}`:""}`,"Economic calendar");
}
export async function fetchEconomicsRevisions():Promise<EconomicsRevisionResponse>{
  return fetchEconomicsJSON<EconomicsRevisionResponse>("/api/economics/revisions","Economic revisions");
}

export async function fetchRateHistory(range: RateHistoryRange): Promise<RateHistoryResponse> {
  return fetchEconomicsJSON<RateHistoryResponse>(`/api/economics/rates/history?range=${encodeURIComponent(range)}`,"Rate history");
}

async function fetchEconomicsJSON<T>(url:string,label:string):Promise<T>{
  let response:Response;
  try{response=await fetch(url,{headers:{Accept:"application/json"}})}catch{return Promise.reject(new Error(`${label} could not reach the local service.`))}
  if(!response.ok){let message=`${label} request failed (${response.status})`;try{const body=await response.json() as {error?:string};if(body.error)message=body.error}catch{/* retain status */}throw new Error(message)}
  try{return await response.json() as T}catch{throw new Error(`${label} returned an invalid cached response.`)}
}
